import React from "react";
import { useNavigate } from "react-router-dom";
import { MissionSubCard, MissionSubCardHorizontalDivider } from "./MissionLayoutComponents";
import { useAlert } from 'react-alert';

import Button from "../../common_components/Button";
import Timeline from "./Timeline";



function MissionCompleted({ mission, userMissionState, refreshMissionStatus }) {
    const navigate = useNavigate();

    return (
        <MissionSubCard>
            <Timeline mission={mission} userMissionState={userMissionState} />
            <MissionSubCardHorizontalDivider showMobile={true} />
            <div className="mission-complete-container">
                <div className="mission-content-card-text">
                    You've completed this mission!
                </div>
                <Button size="medium" color="gray" onClick={() => navigate("/missions")}>Back to missions</Button>
            </div>
        </MissionSubCard>
    )
}

export default MissionCompleted;